import store from './store'

class EventBus {
  modules = {}
  /**
   * Подписывается на навигацию и события приложения и инициализирует impersonation до загрузки услуг.
   */
  async listen () {
    // При смене маршрута (страницы) определяем в какой модуль/услугу осуществлен переход
    window.vue.$router.afterEach((to) => {
      let module = to.matched[0]?.path.slice(1)

      module = (module && store.state.modules.includes(module)) ? module : null

      window.vue.$store.dispatch(
        'handleModuleNavigation',
        module
      )
    })

    window.vue.$on('moduleChanged', ({ from, to }) => {
      store.commit('manager/clear')

      if (to && store.getters['services/isConnected'](to)) {
        store.dispatch('manager/fetch', to)
      }
    })

    window.vue.$on('servicesLoaded', services => {
      for (const module in this.modules) {
        if (services.includes(module)) {
          this.modules[module]()
        }
      }
    })

    // Ждём готовности impersonation-режима, чтобы services/fetch (и весь каскад через
    // servicesLoaded → module.eventBus) ушёл уже с выбранным client_id у менеджера.
    try {
      await store.dispatch('impersonation/fetchMe')
      if (store.state.impersonation.active) {
        await store.dispatch('impersonation/fetchClients')
      }
    } catch (e) {
      // 401 отловит interceptor в apiClient. Прочие ошибки не блокируют дальнейшую инициализацию.
    }

    window.vue.$store.dispatch('services/fetch')
  }
}

export default new EventBus()
